import { call, put } from "redux-saga/effects";
import httpErrorHelpers from "../../services/httpUtilities/httpErrorHelpers";
import api from "../../services/httpUtilities/httpService";
import * as renewalAction from "../actions/onlineRenewal";

function* watcherCheckRenewability({ submitData }, effects) {
  try {
    const response = yield call(api.checkRenewability, submitData);
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(renewalAction.checkRenewabilitySuccess(data.Data));
    } else {
      const message = "Check Renewability Unsuccessful";
      yield put(renewalAction.checkRenewabilityFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      renewalAction.checkRenewabilityFailure,
      effects
    );
  }
}

function* watcherRenewalPayNow(
  { premium, orderNo, nric, policyNo, isRecurring },
  effects
) {
  try {
    const response = yield call(
      api.renewalPayNow,
      premium,
      orderNo,
      nric,
      policyNo,
      isRecurring
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response)
    if (status === 200) {
      yield put(renewalAction.renewalPayNowSuccess(data));
    } else {
      const message = "Renewal PayNow Unsuccessful";
      yield put(renewalAction.renewalPayNowFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      renewalAction.renewalPayNowFailure,
      effects
    );
  }
}

function* watcherGetStatusMessage({ orderNo }, effects) {
  try {
    const response = yield call(api.getStatusMessage, orderNo);
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response)
    if (status === 200) {
      yield put(renewalAction.getStatusMessageSuccess(data));
    } else {
      const message = "Get Status Message Unsuccessful";
      yield put(renewalAction.getStatusMessageFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      renewalAction.getStatusMessageFailure,
      effects
    );
  }
}

//renewal tiq home
function* watcherRenewalTiqHome({ submitData }, effects) {
  try {
    const response = yield call(api.renewalTiqHome, submitData);
    const { data, status } = response;
    const { Message } = data;
    //console.log("res", response);
    if (status === 200) {
      yield put(renewalAction.renewalTiqHomeSuccess(data.Data));
    } else {
      const message = "Renewal Tiq Home Unsuccessful";
      yield put(renewalAction.renewalTiqHomeFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      renewalAction.renewalTiqHomeFailure,
      effects
    );
  }
}

export {
  watcherCheckRenewability,
  watcherRenewalPayNow,
  watcherGetStatusMessage,
  watcherRenewalTiqHome,
};
